import { useEffect, useState } from 'react';

const STYLE = `
  @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Space+Mono:wght@400;700&display=swap');

  .sp-root { background: #F9F7F4; color: #1a1a1a; font-family: 'Space Mono', monospace; }

  /* ── HERO ── */
  .sp-hero {
    background: #FFF8EE; padding: 60px 40px 90px;
    position: relative; overflow: hidden; border-bottom: 1px solid #EDE8DE;
  }
  .sp-hero::before {
    content: ''; position: absolute; inset: 0;
    background-image: radial-gradient(circle, rgba(27,47,232,0.07) 1px, transparent 1px);
    background-size: 28px 28px; pointer-events: none;
  }
  .sp-hero::after {
    content: ''; position: absolute; top: 0; right: 0; bottom: 0; width: 55%;
    background: radial-gradient(ellipse 70% 80% at 85% 45%, rgba(255,214,0,0.13) 0%, transparent 65%);
    pointer-events: none;
  }
  .sp-hero-inner { max-width: 1100px; margin: 0 auto; position: relative; z-index: 2; display: grid; grid-template-columns: 1fr 1fr; align-items: center; gap: 60px; }
  .sp-hero-text { }

  /* ── HERO RIGHT CHAT VISUAL ── */
  .sp-hero-visual { position: relative; height: 400px; display: flex; align-items: center; justify-content: center; }
  .sp-chat-window { width: 300px; background: #fff; border-radius: 20px; box-shadow: 0 24px 64px rgba(0,0,0,0.13), 0 4px 16px rgba(0,0,0,0.06); overflow: hidden; border: 1px solid #E8E4DC; animation: sp-chat-float 5s ease-in-out infinite; }
  @keyframes sp-chat-float { 0%,100%{transform:translateY(0) rotate(-1deg)} 50%{transform:translateY(-12px) rotate(0.5deg)} }
  .sp-chat-header { background: linear-gradient(135deg,#1B2FE8,#3355FF); padding: 14px 18px; display: flex; align-items: center; gap: 10px; }
  .sp-chat-avatar { width: 36px; height: 36px; border-radius: 50%; background: rgba(255,255,255,0.25); display: flex; align-items: center; justify-content: center; font-size: 18px; }
  .sp-chat-hinfo { flex: 1; }
  .sp-chat-hname { font-family: 'Bebas Neue', monospace; font-size: 15px; letter-spacing: 0.08em; color: #fff; line-height: 1.1; }
  .sp-chat-hstatus { font-family: 'Space Mono', monospace; font-size: 8px; color: rgba(255,255,255,0.7); letter-spacing: 0.1em; display: flex; align-items: center; gap: 4px; }
  .sp-chat-dot { width: 6px; height: 6px; border-radius: 50%; background: #4ade80; display: inline-block; animation: sp-blink 2s ease-in-out infinite; }
  @keyframes sp-blink { 0%,100%{opacity:1} 50%{opacity:0.4} }
  .sp-chat-body { background: #ECE5DD; padding: 16px 14px; display: flex; flex-direction: column; gap: 10px; min-height: 220px; }
  .sp-chat-msg { max-width: 80%; padding: 9px 12px; border-radius: 12px; font-family: 'Space Mono', monospace; font-size: 9px; line-height: 1.7; letter-spacing: 0.03em; opacity: 0; }
  .sp-msg-bot { background: #fff; border-radius: 0 12px 12px 12px; color: #333; align-self: flex-start; box-shadow: 0 1px 3px rgba(0,0,0,0.08); }
  .sp-msg-user { background: #DCF8C6; border-radius: 12px 0 12px 12px; color: #1a1a1a; align-self: flex-end; }
  .sp-chat-msg.sp-m1 { animation: sp-msg-in 0.4s ease forwards 0.5s; }
  .sp-chat-msg.sp-m2 { animation: sp-msg-in 0.4s ease forwards 1.4s; }
  .sp-chat-msg.sp-m3 { animation: sp-msg-in 0.4s ease forwards 2.3s; }
  .sp-chat-msg.sp-m4 { animation: sp-msg-in 0.4s ease forwards 3.2s; }
  @keyframes sp-msg-in { from{opacity:0;transform:translateY(8px)} to{opacity:1;transform:translateY(0)} }
  .sp-chat-typing { display: flex; align-items: center; gap: 4px; padding: 9px 12px; background: #fff; border-radius: 0 12px 12px 12px; width: fit-content; box-shadow: 0 1px 3px rgba(0,0,0,0.08); opacity: 0; animation: sp-msg-in 0.4s ease forwards 4.0s; }
  .sp-chat-typing span { width: 6px; height: 6px; border-radius: 50%; background: #999; }
  .sp-chat-typing span:nth-child(1) { animation: sp-type 1.2s ease-in-out infinite 0.0s; }
  .sp-chat-typing span:nth-child(2) { animation: sp-type 1.2s ease-in-out infinite 0.2s; }
  .sp-chat-typing span:nth-child(3) { animation: sp-type 1.2s ease-in-out infinite 0.4s; }
  @keyframes sp-type { 0%,60%,100%{transform:translateY(0)} 30%{transform:translateY(-5px)} }
  .sp-chat-input { background: #f0f0f0; padding: 10px 14px; display: flex; align-items: center; gap: 8px; border-top: 1px solid #E8E4DC; }
  .sp-chat-input-box { flex: 1; font-family: 'Space Mono', monospace; font-size: 9px; color: #999; letter-spacing: 0.04em; }
  .sp-chat-send { width: 28px; height: 28px; border-radius: 50%; background: #1B2FE8; display: flex; align-items: center; justify-content: center; font-size: 12px; }
  .sp-float-badge { position: absolute; background: #fff; border: 1.5px solid #E8E4DC; border-radius: 8px; padding: 7px 12px; font-family: 'Space Mono', monospace; font-size: 9px; font-weight: 700; color: #1a1a1a; letter-spacing: 0.08em; white-space: nowrap; box-shadow: 0 4px 14px rgba(0,0,0,0.06); }
  .sp-float-badge b { color: #1B2FE8; }
  .sp-fb-1 { top: 5%; right: 2%; animation: sp-flt-up 4s ease-in-out infinite; }
  .sp-fb-2 { bottom: 10%; left: 0%; animation: sp-flt-dn 3.5s ease-in-out infinite 0.5s; }
  @keyframes sp-flt-up { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-7px)} }
  @keyframes sp-flt-dn { 0%,100%{transform:translateY(0)} 50%{transform:translateY(7px)} }

  @media(max-width:900px) { .sp-hero-inner { grid-template-columns:1fr; } .sp-hero-visual { display:none; } }
  .sp-eyebrow {
    display: inline-flex; align-items: center; gap: 8px;
    border: 1px solid rgba(27,47,232,0.2); border-radius: 2px;
    font-family: 'Space Mono', monospace; font-size: 10px; font-weight: 700;
    letter-spacing: 0.25em; color: #1B2FE8; padding: 6px 16px; margin-bottom: 28px;
    text-transform: uppercase; background: rgba(27,47,232,0.04);
  }
  .sp-hero-title {
    font-family: 'Bebas Neue', monospace;
    font-size: clamp(60px,9vw,112px); line-height: 0.92;
    letter-spacing: 0.01em; color: #1a1a1a; margin-bottom: 28px;
  }
  .sp-hero-title em { color: #1B2FE8; font-style: normal; display: block; }
  .sp-hero-desc { font-family: 'Space Mono', monospace; font-size: 12px; line-height: 2; color: #888; max-width: 540px; letter-spacing: 0.06em; }

  /* ── CHANNELS ── */
  .sp-channels-section { background: #F9F7F4; padding: 60px 40px; }
  .sp-channels-inner { max-width: 1100px; margin: 0 auto; }
  .sp-section-eyebrow { font-family: 'Space Mono', monospace; font-size: 10px; font-weight: 700; letter-spacing: 0.3em; text-transform: uppercase; color: #999; margin-bottom: 16px; }
  .sp-section-title { font-family: 'Bebas Neue', monospace; font-size: clamp(40px,5vw,68px); letter-spacing: 0.02em; color: #1a1a1a; margin-bottom: 36px; line-height: 1; }
  .sp-section-title em { color: #1B2FE8; font-style: normal; }
  .sp-channels { display: grid; grid-template-columns: repeat(3,1fr); gap: 1px; background: #E8E4DC; border: 1px solid #E8E4DC; }
  .sp-channel { background: #F9F7F4; padding: 40px 32px; transition: background 0.2s; }
  .sp-channel:hover { background: #fff; }
  .sp-channel-band { height: 3px; width: 40px; margin-bottom: 28px; }
  .sp-channel-icon { font-size: 32px; margin-bottom: 18px; display: block; }
  .sp-channel-title { font-family: 'Bebas Neue', monospace; font-size: 26px; letter-spacing: 0.04em; color: #1a1a1a; margin-bottom: 12px; }
  .sp-channel-desc { font-family: 'Space Mono', monospace; font-size: 10px; line-height: 1.9; color: #888; margin-bottom: 20px; }
  .sp-channel-hours { font-family: 'Space Mono', monospace; font-size: 9px; font-weight: 700; letter-spacing: 0.15em; text-transform: uppercase; color: #1B2FE8; }

  /* ── FAQ ── */
  .sp-faq-section {
    background: linear-gradient(160deg, #1C1C20 0%, #16161A 60%, #1A1620 100%);
    padding: 60px 40px; border-top: 1px solid rgba(255,214,0,0.1);
    position: relative; overflow: hidden;
  }
  .sp-faq-section::before {
    content: ''; position: absolute; inset: 0;
    background: radial-gradient(ellipse 50% 60% at 25% 50%, rgba(27,47,232,0.08) 0%, transparent 70%);
    pointer-events: none;
  }
  .sp-faq-section::after {
    content: ''; position: absolute;
    top: 0; bottom: 0; left: -55%; width: 55%;
    background: linear-gradient(90deg, transparent 0%, rgba(27,47,232,0.07) 35%, rgba(255,214,0,0.05) 55%, rgba(27,47,232,0.07) 75%, transparent 100%);
    animation: sp-wave-pass 9s linear infinite;
    pointer-events: none; z-index: 0;
  }
  @keyframes sp-wave-pass { from{left:-55%} to{left:155%} }
  .sp-faq-inner { max-width: 800px; margin: 0 auto; position: relative; z-index: 1; }
  .sp-faq-title { font-family: 'Bebas Neue', monospace; font-size: clamp(40px,5vw,64px); letter-spacing: 0.02em; color: #fff; margin-bottom: 8px; }
  .sp-faq-title em { color: #FFD600; font-style: normal; }
  .sp-faq-sub { font-family: 'Space Mono', monospace; font-size: 10px; letter-spacing: 0.2em; color: rgba(255,255,255,0.4); text-transform: uppercase; margin-bottom: 32px; }
  .sp-acc-list { display: flex; flex-direction: column; }
  .sp-acc-item { border-top: 1px solid rgba(255,255,255,0.1); }
  .sp-acc-item:last-child { border-bottom: 1px solid rgba(255,255,255,0.1); }
  .sp-acc-q { width: 100%; background: none; border: none; padding: 22px 0; display: flex; align-items: center; gap: 20px; cursor: pointer; text-align: left; }
  .sp-acc-num { font-family: 'Space Mono', monospace; font-size: 10px; font-weight: 700; letter-spacing: 0.15em; color: rgba(255,255,255,0.3); flex-shrink: 0; min-width: 28px; }
  .sp-acc-q-text { font-family: 'Bebas Neue', monospace; font-size: 22px; letter-spacing: 0.04em; color: rgba(255,255,255,0.85); flex: 1; }
  .sp-acc-item.open .sp-acc-q-text { color: #fff; }
  .sp-acc-icon { font-family: 'Space Mono', monospace; font-size: 18px; color: rgba(255,255,255,0.3); transition: transform 0.3s; flex-shrink: 0; }
  .sp-acc-item.open .sp-acc-icon { transform: rotate(45deg); color: #FFD600; }
  .sp-acc-body { max-height: 0; overflow: hidden; transition: max-height 0.4s cubic-bezier(.4,0,.2,1); }
  .sp-acc-item.open .sp-acc-body { max-height: 200px; }
  .sp-acc-content { padding: 0 0 24px 48px; font-family: 'Space Mono', monospace; font-size: 10px; line-height: 2; color: rgba(255,255,255,0.5); letter-spacing: 0.06em; }

  /* ── QUICK LINKS ── */
  .sp-links-section { background: #fff; padding: 60px 40px; border-top: 1px solid #E8E4DC; }
  .sp-links-inner { max-width: 1100px; margin: 0 auto; }
  .sp-links-grid { display: grid; grid-template-columns: repeat(4,1fr); gap: 1px; background: #E8E4DC; border: 1px solid #E8E4DC; margin-top: 64px; }
  .sp-link-card { background: #fff; padding: 36px 28px; text-decoration: none; color: inherit; display: block; transition: background 0.2s; }
  .sp-link-card:hover { background: #F9F7F4; }
  .sp-link-icon { font-size: 28px; margin-bottom: 16px; display: block; }
  .sp-link-title { font-family: 'Bebas Neue', monospace; font-size: 22px; letter-spacing: 0.04em; color: #1a1a1a; margin-bottom: 8px; }
  .sp-link-desc { font-family: 'Space Mono', monospace; font-size: 9px; line-height: 1.8; color: #999; }
  .sp-link-arrow { font-family: 'Space Mono', monospace; font-size: 11px; color: #1B2FE8; margin-top: 16px; display: block; font-weight: 700; }

  /* ── FOLLOW ALONG ── */
  .sp-social-section {
    background: linear-gradient(150deg, #1E1B2E 0%, #1A1824 60%, #1C1A28 100%);
    padding: 60px 40px; border-top: 1px solid rgba(255,214,0,0.1);
    position: relative; overflow: hidden;
  }
  .sp-social-section::before {
    content: ''; position: absolute; inset: 0;
    background: radial-gradient(ellipse 60% 50% at 50% 0%, rgba(255,214,0,0.05) 0%, transparent 70%);
    pointer-events: none;
  }
  .sp-social-section::after {
    content: ''; position: absolute;
    top: 0; bottom: 0; left: -55%; width: 55%;
    background: linear-gradient(90deg, transparent 0%, rgba(255,214,0,0.05) 30%, rgba(27,47,232,0.06) 55%, rgba(255,214,0,0.05) 75%, transparent 100%);
    animation: sp-wave-pass 7s linear infinite 2s;
    pointer-events: none; z-index: 0;
  }
  .sp-social-inner { max-width: 800px; margin: 0 auto; position: relative; z-index: 1; }
  .sp-social-title { font-family: 'Bebas Neue', monospace; font-size: clamp(40px,5vw,64px); letter-spacing: 0.02em; color: #fff; margin-bottom: 8px; }
  .sp-social-title span { color: #FFD600; }
  .sp-social-sub { font-family: 'Space Mono', monospace; font-size: 10px; letter-spacing: 0.2em; color: rgba(255,255,255,0.4); text-transform: uppercase; margin-bottom: 32px; }
  .sp-signpost-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
  .sp-signpost {
    display: flex; align-items: center; gap: 16px; padding: 18px 20px;
    border-radius: 16px; border: 1px solid rgba(255,255,255,0.08);
    background: rgba(255,255,255,0.04); cursor: pointer; position: relative; overflow: hidden;
    transition: border-color 0.25s, background 0.25s, box-shadow 0.25s, transform 0.25s;
  }
  /* shimmer sweep on hover */
  .sp-signpost::before {
    content:''; position:absolute; top:0; left:-75%; width:50%; height:100%;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.07), transparent);
    transition: left 0.5s ease; pointer-events:none;
  }
  .sp-signpost:hover::before { left: 125%; }
  .sp-signpost:hover {
    background: rgba(255,255,255,0.09); border-color: rgba(255,214,0,0.35);
    box-shadow: 0 8px 28px rgba(0,0,0,0.25), 0 0 0 1px rgba(255,214,0,0.12);
    transform: translateY(-3px);
  }
  /* staggered float animations */
  .sp-signpost:nth-child(1){animation:sp-flt-a 3.6s ease-in-out infinite 0.0s}
  .sp-signpost:nth-child(2){animation:sp-flt-b 3.2s ease-in-out infinite 0.3s}
  .sp-signpost:nth-child(3){animation:sp-flt-a 3.8s ease-in-out infinite 0.6s}
  .sp-signpost:nth-child(4){animation:sp-flt-b 3.4s ease-in-out infinite 0.9s}
  .sp-signpost:nth-child(5){animation:sp-flt-a 3.5s ease-in-out infinite 1.2s}
  .sp-signpost:nth-child(6){animation:sp-flt-b 3.9s ease-in-out infinite 1.5s}
  @keyframes sp-flt-a { 0%,100%{transform:translateY(0)}   50%{transform:translateY(-6px)} }
  @keyframes sp-flt-b { 0%,100%{transform:translateY(-4px)} 50%{transform:translateY(4px)}  }

  .sp-signpost-icon-wrap {
    width: 50px; height: 50px; border-radius: 14px;
    display: flex; align-items: center; justify-content: center;
    flex-shrink: 0; border: 1px solid rgba(255,255,255,0.12);
    transition: transform 0.25s, box-shadow 0.25s;
  }
  .sp-signpost:hover .sp-signpost-icon-wrap { transform: scale(1.1); box-shadow: 0 4px 16px rgba(0,0,0,0.3); }
  .sp-signpost-icon-wrap svg { width: 26px; height: 26px; display: block; }
  .sp-signpost-name { font-family: 'Bebas Neue', monospace; font-size: 20px; letter-spacing: 0.06em; color: #fff; line-height: 1; margin-bottom: 3px; }
  .sp-signpost-handle { font-family: 'Space Mono', monospace; font-size: 9px; color: rgba(255,255,255,0.35); letter-spacing: 0.1em; }
  .sp-signpost-arrow { margin-left: auto; font-size: 16px; color: rgba(255,255,255,0.2); transition: color 0.2s, transform 0.2s; flex-shrink: 0; }
  .sp-signpost:hover .sp-signpost-arrow { color: #FFD600; transform: translateX(3px); }

  @media (max-width: 600px) { .sp-signpost-grid { grid-template-columns: 1fr; } }

  /* REVEAL */
  .sp-reveal { opacity: 0; transform: translateY(28px); transition: opacity 0.7s ease, transform 0.7s ease; }
  .sp-reveal.visible { opacity: 1; transform: translateY(0); }

  @media (max-width:960px) {
    .sp-channels { grid-template-columns: repeat(2,1fr); }
    .sp-links-grid { grid-template-columns: repeat(2,1fr); }
  }
  @media (max-width:600px) {
    .sp-channels { grid-template-columns: 1fr; }
    .sp-links-grid { grid-template-columns: 1fr 1fr; }
    .sp-channels-section, .sp-faq-section, .sp-links-section { padding-left: 20px; padding-right: 20px; }
  }
`;

function injectStyle(id, css) {
  if (typeof document === 'undefined') return;
  if (document.getElementById(id)) return;
  const el = document.createElement('style');
  el.id = id; el.textContent = css;
  document.head.appendChild(el);
}

function useReveal() {
  useEffect(() => {
    const els = document.querySelectorAll('.sp-reveal');
    const io = new IntersectionObserver(
      entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); }),
      { threshold: 0.08 }
    );
    els.forEach(el => io.observe(el));
    return () => io.disconnect();
  }, []);
}

function AccItem({ num, q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`sp-acc-item${open ? ' open' : ''}`}>
      <button className="sp-acc-q" onClick={() => setOpen(v => !v)}>
        <span className="sp-acc-num">{num}</span>
        <span className="sp-acc-q-text">{q}</span>
        <span className="sp-acc-icon">+</span>
      </button>
      <div className="sp-acc-body">
        <div className="sp-acc-content">{a}</div>
      </div>
    </div>
  );
}

const CHANNELS = [
  { icon: '💬', band: '#1B2FE8', title: 'Live Chat',    desc: 'Instant answers from our support team. Available Monday–Friday during business hours.', hours: 'Mon – Fri · 9 AM – 7 PM IST' },
  { icon: '📧', band: '#FFD600', title: 'Email Support', desc: 'Send us a detailed query and we\'ll respond within one business day with a full solution.', hours: 'Response within 24 hours' },
  { icon: '📞', band: '#1a1a1a', title: 'Phone / Call',  desc: 'Prefer to talk? Book a call with your dedicated account manager for complex issues.', hours: 'By appointment · Mon – Fri' },
];

const FAQS = [
  { num: '01', q: 'How long before I see results from digital marketing?', a: 'SEO typically takes 3–6 months. Paid ads can show results within days. We set clear timelines during onboarding so you always know what to expect and when.' },
  { num: '02', q: 'What is the minimum monthly budget for paid ads?', a: 'We recommend a minimum ad spend of ₹30,000/month for Google or Meta campaigns to generate statistically meaningful data and optimise effectively.' },
  { num: '03', q: 'Do you provide monthly reports?', a: 'Yes. Every client receives a detailed monthly performance report with KPIs, campaign breakdown, insights and next-step recommendations.' },
  { num: '04', q: 'Can I pause or cancel my plan?', a: 'Absolutely. Our plans are flexible. You can pause, upgrade or cancel with 30 days notice. No hidden lock-in fees.' },
  { num: '05', q: 'Do you work with businesses outside India?', a: 'Yes — we serve clients across India, the UAE, UK and USA. All billing can be handled in INR, USD or GBP.' },
];

/* ── Real SVG brand icons ── */
const SvgX = () => (
  <svg viewBox="0 0 24 24" fill="#fff"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.253 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
);
const SvgYouTube = () => (
  <svg viewBox="0 0 24 24" fill="#fff"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
);
const SvgInstagram = () => (
  <svg viewBox="0 0 24 24" fill="#fff"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
);
const SvgLinkedIn = () => (
  <svg viewBox="0 0 24 24" fill="#fff"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
);
const SvgWhatsApp = () => (
  <svg viewBox="0 0 24 24" fill="#fff"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
);
const SvgTelegram = () => (
  <svg viewBox="0 0 24 24" fill="#fff"><path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/></svg>
);

const SOCIALS = [
  { Svg: SvgX,         name: 'Twitter / X', handle: '@digitalagency',   iconBg: '#000000',                                                             url: 'https://twitter.com/digitalagency'           },
  { Svg: SvgYouTube,   name: 'YouTube',     handle: '@DigitalAgencyHQ', iconBg: '#FF0000',                                                             url: 'https://youtube.com/@DigitalAgencyHQ'        },
  { Svg: SvgInstagram, name: 'Instagram',   handle: '@digital.agency',  iconBg: 'linear-gradient(135deg,#f09433,#e6683c,#dc2743,#cc2366,#bc1888)',     url: 'https://instagram.com/digital.agency'        },
  { Svg: SvgLinkedIn,  name: 'LinkedIn',    handle: 'Digital Agency',   iconBg: '#0A66C2',                                                             url: 'https://linkedin.com/company/digital-agency' },
  { Svg: SvgWhatsApp,  name: 'WhatsApp',    handle: '+91 99999 99999',  iconBg: '#25D366',                                                             url: 'https://wa.me/919999999999'                  },
  { Svg: SvgTelegram,  name: 'Telegram',    handle: '@digitalagency',   iconBg: '#26A5E4',                                                             url: 'https://t.me/digitalagency'                  },
];

const QUICK_LINKS = [
  { icon: '📖', title: 'Documentation',  desc: 'Step-by-step guides on campaign setup, tracking and reporting.',    arrow: 'Browse Docs →' },
  { icon: '🎥', title: 'Video Tutorials', desc: 'Watch our walkthrough videos to get up to speed quickly.',           arrow: 'Watch Now →' },
  { icon: '🗓️', title: 'Book a Call',     desc: 'Schedule a 30-minute strategy session with our team.',               arrow: 'Book Now →' },
  { icon: '🐛', title: 'Report an Issue', desc: 'Found a bug or billing discrepancy? Report it and we\'ll fix it fast.', arrow: 'Submit →' },
];

export default function Support() {
  useEffect(() => { injectStyle('sp-styles', STYLE); }, []);
  useReveal();

  return (
    <div className="sp-root">

      {/* HERO */}
      <section className="sp-hero">
        <div className="sp-hero-inner">
          <div className="sp-hero-text">
            <div className="sp-eyebrow sp-reveal">Help Center</div>
            <h1 className="sp-hero-title sp-reveal">
              WE ARE HERE<br />
              <em>TO HELP.</em><br />
              ALWAYS.
            </h1>
            <p className="sp-hero-desc sp-reveal">
              Have a question, facing an issue, or need guidance on your campaign?
              Our support team is ready — reach us the way that works best for you.
            </p>
          </div>

          {/* Right animated chat visual */}
          <div className="sp-hero-visual">
            <div className="sp-chat-window">
              <div className="sp-chat-header">
                <div className="sp-chat-avatar">🎯</div>
                <div className="sp-chat-hinfo">
                  <div className="sp-chat-hname">Support Team</div>
                  <div className="sp-chat-hstatus"><span className="sp-chat-dot" /> Online Now</div>
                </div>
              </div>
              <div className="sp-chat-body">
                <div className="sp-chat-msg sp-msg-bot sp-m1">👋 Hi! How can we help you grow your brand today?</div>
                <div className="sp-chat-msg sp-msg-user sp-m2">I need help with my SEO strategy.</div>
                <div className="sp-chat-msg sp-msg-bot sp-m3">Great! Our SEO team can audit your site and build a roadmap. Want to book a free call?</div>
                <div className="sp-chat-msg sp-msg-user sp-m4">Yes please!</div>
                <div className="sp-chat-typing">
                  <span /><span /><span />
                </div>
              </div>
              <div className="sp-chat-input">
                <div className="sp-chat-input-box">Type a message...</div>
                <div className="sp-chat-send">➤</div>
              </div>
            </div>
            <div className="sp-float-badge sp-fb-1">⚡ <b>Avg reply: 2 min</b></div>
            <div className="sp-float-badge sp-fb-2">✅ <b>94%</b> Satisfaction</div>
          </div>
        </div>
      </section>

      {/* SUPPORT CHANNELS */}
      <section className="sp-channels-section">
        <div className="sp-channels-inner">
          <p className="sp-section-eyebrow sp-reveal">Reach Us</p>
          <h2 className="sp-section-title sp-reveal">Support <em>Channels</em></h2>
          <div className="sp-channels sp-reveal">
            {CHANNELS.map((c, i) => (
              <div className="sp-channel" key={i}>
                <div className="sp-channel-band" style={{ background: c.band }} />
                <span className="sp-channel-icon">{c.icon}</span>
                <div className="sp-channel-title">{c.title}</div>
                <p className="sp-channel-desc">{c.desc}</p>
                <span className="sp-channel-hours">{c.hours}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="sp-faq-section">
        <div className="sp-faq-inner">
          <h2 className="sp-faq-title sp-reveal">Frequently <em>Asked</em></h2>
          <p className="sp-faq-sub sp-reveal">Common questions — answered clearly</p>
          <div className="sp-acc-list sp-reveal">
            {FAQS.map((f, i) => (
              <AccItem key={i} num={f.num} q={f.q} a={f.a} />
            ))}
          </div>
        </div>
      </section>

      {/* QUICK LINKS */}
      <section className="sp-links-section">
        <div className="sp-links-inner">
          <p className="sp-section-eyebrow sp-reveal">Self-Service</p>
          <h2 className="sp-section-title sp-reveal">Quick <em>Resources</em></h2>
          <div className="sp-links-grid sp-reveal">
            {QUICK_LINKS.map((l, i) => (
              <a href="#" className="sp-link-card" key={i}>
                <span className="sp-link-icon">{l.icon}</span>
                <div className="sp-link-title">{l.title}</div>
                <p className="sp-link-desc">{l.desc}</p>
                <span className="sp-link-arrow">{l.arrow}</span>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* FOLLOW ALONG */}
      <section className="sp-social-section">
        <div className="sp-social-inner">
          <h2 className="sp-social-title sp-reveal">Follow <span>Along</span></h2>
          <p className="sp-social-sub sp-reveal">Stay connected across platforms</p>
          <div className="sp-signpost-grid sp-reveal">
            {SOCIALS.map((s, i) => (
              <a key={i} className="sp-signpost" href={s.url} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                <div className="sp-signpost-icon-wrap" style={{ background: s.iconBg }}>
                  <s.Svg />
                </div>
                <div>
                  <div className="sp-signpost-name">{s.name}</div>
                  <div className="sp-signpost-handle">{s.handle}</div>
                </div>
                <div className="sp-signpost-arrow">→</div>
              </a>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
}
